export interface Attribute {
  readonly id: number;
  parentAttributeId?: number;
  parentAttribute?: any;
  projectId?: number;
  project?: any;
  class?: string;
  name?: string;
  icon?: string;
  color?: string;
  guid?: string;
  state?: string;
  image?: any;
  order?: number;
  selected?: boolean;
  configs?: any;
  objectConfigs?: any;
}
